import(/* webpackMode: "eager" */ "/home/circleci/project/PageApp-Purchase/src/app/error.tsx");
